import type { FieldOption } from '../types';

export const industryOptions: FieldOption[] = [
  { value: '1', label: '1 — Unilever' },
  { value: '2', label: '2 — Multi' },
  { value: '3', label: '3 — E-UB' },
];

export const sellerOptions: FieldOption[] = [
  { value: 'carrefour', label: 'Carrefour' },
  { value: 'extra', label: 'Extra' },
  { value: 'atacadao', label: 'Atacadão' },
  { value: 'sam_club', label: "Sam's Club" },
  { value: 'pao_acucar', label: 'Pão de Açúcar' },
  { value: 'assai', label: 'Assaí Atacadista' },
  { value: 'makro', label: 'Makro' },
  { value: 'coop', label: 'Coop' },
  { value: 'condor', label: 'Condor' },
  { value: 'bistek', label: 'Bistek' },
  { value: 'zona_sul', label: 'Zona Sul' },
  { value: 'prezunic', label: 'Prezunic' },
  { value: 'oba', label: 'OBA Hortifruti' },
  { value: 'verdemar', label: 'Verdemar' },
  { value: 'hirota', label: 'Hirota Food Supermercado' },
];
